import { render, staticRenderFns } from "./AssignClientsDialog.vue?vue&type=template&id=ef54127c&scoped=true"
import script from "./AssignClientsDialog.vue?vue&type=script&lang=js"
export * from "./AssignClientsDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignClientsDialog.vue?vue&type=style&index=0&id=ef54127c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef54127c",
  null
  
)

export default component.exports